var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export function VcaFill(_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.196 21.021 4 20.55 4 20V4C4 3.45 4.196 2.979 4.588 2.587C4.97933 2.19567 5.45 2 6 2H14L20 8V20C20 20.55 19.8043 21.021 19.413 21.413C19.021 21.8043 18.55 22 18 22H6ZM11 19H13V18H14C14.2833 18 14.521 17.904 14.713 17.712C14.9043 17.5207 15 17.2833 15 17V14C15 13.7167 14.9043 13.479 14.713 13.287C14.521 13.0957 14.2833 13 14 13H11V12H15V10H13V9H11V10H10C9.71667 10 9.47933 10.0957 9.288 10.287C9.096 10.479 9 10.7167 9 11V14C9 14.2833 9.096 14.5207 9.288 14.712C9.47933 14.904 9.71667 15 10 15H13V16H9V18H11V19ZM13.175 8H17.175L13.175 4V8Z", fill: color }) })));
}
